import { cn as i } from "../../../lib/utils.es.js";
import { cva as l } from "class-variance-authority";
var t = l("lib:box-border lib:inline-flex lib:h-11 lib:shrink-0 lib:cursor-pointer lib:items-center lib:justify-center lib:gap-2 lib:whitespace-nowrap lib:rounded-4xl lib:border-2 lib:border-transparent lib:px-6 lib:py-3 lib:font-bold lib:font-cygre lib:s:text-button-md lib:text-button-sm lib:uppercase lib:outline-2 lib:outline-transparent lib:-outline-offset-4 lib:transition-all lib:duration-250 lib:focus-visible:ring-1 lib:disabled:pointer-events-none lib:disabled:cursor-not-allowed lib:md:text-button-md lib:lg:h-14 lib:lg:px-8 lib:lg:py-4 lib:lg:text-button-xl lib:xl:text-button-xl lib:[&_svg]:size-4.5 lib:[&_svg]:shrink-0 lib:[&_svg]:text-current lib:[&_svg]:lg:size-6", {
  variants: {
    variant: {
      primary: i("lib:bg-primary lib:text-white lib:hover:bg-primary-80 lib:focus-visible:border-primary-90 lib:focus-visible:outline-white lib:disabled:opacity-60"),
      accent: i("lib:bg-accent-lime lib:text-dark-90 lib:hover:bg-accent-lime-light lib:focus-visible:border-primary-50 lib:focus-visible:outline-white lib:disabled:opacity-60"),
      white: i("lib:bg-white lib:text-dark-90 lib:hover:bg-primary-10 lib:focus-visible:border-primary-50 lib:disabled:opacity-40"),
      dark: i("lib:bg-dark-90 lib:text-white lib:hover:bg-dark-80 lib:focus-visible:border-primary lib:focus-visible:outline-white lib:disabled:opacity-40"),
      outline: i("lib:border lib:border-white lib:text-white lib:-outline-offset-2 lib:hover:bg-white lib:hover:text-dark-90 lib:focus-visible:border-transparent lib:focus-visible:outline-primary-50 lib:disabled:opacity-60"),
      outlineDark: i("lib:border lib:border-dark-90 lib:text-dark-90 lib:-outline-offset-2 lib:hover:bg-dark-90 lib:hover:text-white lib:focus-visible:border-transparent lib:focus-visible:outline-primary lib:disabled:opacity-60"),
      linkLight: i("lib:text-dark-40 lib:outline-offset-0 lib:hover:text-white lib:focus-visible:outline-primary-50"),
      linkDark: i("lib:text-dark-80 lib:outline-offset-0 lib:hover:text-dark-100 lib:focus-visible:outline-primary-100"),
      ghost: i("lib:text-white lib:hover:bg-white lib:hover:text-dark-90 lib:focus-visible:bg-white lib:focus-visible:text-dark-90 lib:disabled:text-dark-60"),
      ghostDark: i("lib:hover:bg-primary lib:hover:text-white lib:focus-visible:bg-primary lib:focus-visible:text-white lib:disabled:text-dark-60")
    },
    icon: {
      false: null,
      true: "lib:rounded-full"
    }
  },
  compoundVariants: [{
    icon: !0,
    className: "lib:size-11 lib:min-h-0! lib:p-0 lib:lg:size-14 lib:lg:p-0"
  }],
  defaultVariants: {
    variant: "primary",
    icon: !1
  }
});
export {
  t as buttonVariants
};
